import { Entry, SupportInformationContentModel } from '@cibo/core'
import { Markdown } from '@cibo/ui'
import {
  Button,
  ButtonProps,
  Dialog,
  DialogContent,
  Divider,
  Link,
  Stack,
  Typography,
} from '@mui/material'
import { EntrySkeletonType } from 'contentful'
import { Children, PropsWithChildren, ReactElement, cloneElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelfOrgContent } from '../../queries'

export const ContactSupportButton = ({
  buttonText,
  renderAs,
  children,
  onClose,
  link = false,
  ...rest
}: PropsWithChildren<
  ButtonProps & {
    buttonText?: string
    onClose?: () => void
    renderAs?: ReactElement
    link?: boolean
  }
>) => {
  const { t } = useTranslation('contactSupportButton')
  const [openModal, setOpenModal] = useState(false)
  const orgContent = useSelfOrgContent()

  return (
    <>
      {!!renderAs ? (
        Children.map(renderAs, child => {
          if (!child) {
            return null
          }
          return cloneElement(child, {
            onClick: (e: any) => setOpenModal(true),
            disabled: orgContent.isError,
          })
        })
      ) : link ? (
        <Link onClick={() => setOpenModal(true)}>
          {!!children ? children : !!buttonText ? buttonText : t('buttonValue')}
        </Link>
      ) : (
        <Button
          loading={orgContent.isPending || orgContent.isFetching}
          disabled={orgContent.isError}
          variant="contained"
          onClick={() => setOpenModal(true)}
          {...rest}
        >
          {!!children ? children : !!buttonText ? buttonText : t('buttonValue')}
        </Button>
      )}
      <Dialog
        open={openModal}
        onClose={() => {
          onClose && onClose()
          setOpenModal(false)
        }}
      >
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="h6">{t('title')}</Typography>
            <Divider />
            <Markdown typographyProps={{ variant: 'body1' }}>
              {
                (
                  orgContent.data?.fields.supportInformation as unknown as Entry<
                    EntrySkeletonType<SupportInformationContentModel>
                  >
                )?.fields?.helpDialogBody
              }
            </Markdown>
            <Stack direction="row" justifyContent="end">
              <Button onClick={() => setOpenModal(false)}>{t('close')}</Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  )
}
